import React from 'react'
import Chart from 'react-apexcharts'

type Props = {
  series?: any[]
  labels?: string[]
}

export default function ColumnChart({ labels, series }: Props) {
  return (
    <div
      className="bar"
      style={{
        minWidth: '128px',
        minHeight: '104px'
      }}
    >
      <Chart
        options={{
          responsive: [
            {
              breakpoint: 1720,
              options: {
                legend: {
                  position: 'bottom',
                  fontSize: '14'
                },
                chart: {
                  width: '100%',
                  height: '100%'
                }
              }
            }
          ],
          labels: labels ?? [],
          dataLabels: {
            enabled: false
          },
          chart: {
            height: '100%',
            toolbar: {
              show: false
            }
          },
          plotOptions: {
            bar: {
              borderRadius: 8,
              columnWidth: '35px'
            }
          },
          tooltip: {
            enabled: false
          },
          grid: {
            show: false
          },
          yaxis: {
            show: false
          }
        }}
        series={series ?? []}
        type="bar"
      />
    </div>
  )
}
